import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import './home.css'
import { LinkedIn, Http } from '@mui/icons-material';
import { useGlobal } from '../../utils/GlobalContext';
import { session } from '../../data/session';
import { UserPresentation } from '../../data/userProfile';

export default function EventKeynoteComponent() {
    const { state } = useGlobal();
    //Filter for keynote sessions
    const [keynoteSessions, setKeynotes] = useState<session[]>();
    useEffect(()=>{
        if(state.SelectedEvent?.Sessions.length!==0 && keynoteSessions?.length===undefined){
            const filteredKeynotes: session[] = state.SelectedEvent?.Sessions.filter(function (el) {
                return el.IsKeynote===true;
            });
            setKeynotes(filteredKeynotes);
        }
    });
    return ( 
        <>
            <br/>
            <br/>
            <br/>
            <center>
                {keynoteSessions!==undefined &&
                <><h2 className='blueText'>{state.SelectedEvent?.Name} Keynote{keynoteSessions!==undefined && keynoteSessions?.length>1?`s`:``}</h2>
                </>}
            </center>
            {
            keynoteSessions?.map((keynote) => (
                <>
                <Card sx={{ minWidth: 275 }} style={{ border: 'none', boxShadow: 'none' }}>
                    <br/>
                    <br/>
                    <CardContent>
                    
                    <Grid container spacing={4}>
                        
                        {/* <Grid item xs={12} md={4}>
      
                        </Grid> */}
                        <Grid item xs={12} md={12}>
                            <center>
                                <h2>{keynote.Title}</h2>
                                <div className="keynoteParent">
                                {
                                    state.Profiles.map((profile) => (
                                        profile.PresentationSessions.find((element) => element.EventId === keynote.EventId && element.SessionId === keynote.Id)!==undefined &&
                                        <div className="keynoteChild">
                                            <center>
                                                <img className='KeynoteImage' src={profile.PictureLink} alt='KeyNoteSpeaker'/>
                                                <h3 className='blueText'>{profile.FirstName} {profile.LastName}</h3>
                                            </center>
                                        </div>
                                    )
                                    )
                                }
                                </div>
                            </center>
                            <div>{keynote.Description}</div>
                        </Grid>
                    </Grid>
                    </CardContent>
                </Card>
            </>
            
            ))}
        </>
    )
};